import { INITIAL_PURSE_NEXT_WORLD_SERIES } from "@/utils/constants";

export const prizeCalculatorWorldSeries = (
    playersCount: number,
) => {
    if (!playersCount || playersCount < 10) return [30000]; //first player gets 30.000

    const sideGamesReserved = 20000;
    const prizeScalingRatio: number = 0.3;
    const topPlayers = Math.trunc(playersCount * 0.3); // Top 30% of players

    const players = Array.from({ length: playersCount }, (_, index) => ({
        rank: playersCount - index, // Rank from highest to lowest
        points: 0,
        scale: 0,
        prize: 0,
    }));

    const totalPrizePool = INITIAL_PURSE_NEXT_WORLD_SERIES - 30000 - sideGamesReserved; // Total money to distribute

    // Step 1: Set q(1) = 30000
    players[0].prize = 30000; // First place gets $30,000

    // Step 2: Set q(i) = 0 if i > M (initialize prizes for ranks beyond top 30%)
    for (let i = topPlayers; i < playersCount; i++) {
        players[i].prize = 0; // Players outside the top 30% receive nothing
    }

    // Step 3: Calculate points and scales for 2 <= j <= M
    let P = 0; // Total of points for players 2 to M
    for (let j = 2; j <= topPlayers; j++) {
        const scale = Math.max(1, 15 * Math.pow(1 - prizeScalingRatio, j - 2)); // Calculate scale

        players[j - 1].scale = scale; // Save scale to player
        players[j - 1].points = (topPlayers - j + 1) * scale; // Points based on rank
        P += players[j - 1].points; // Sum up points
    }

    // Step 4: Set q(j) = max(100, p(j) / P * totalPrizePool) for 2 <= j <= M
    let Q = 0; // Total of q(j)
    for (let j = 3; j <= topPlayers; j++) {
        players[j - 1].prize = Math.max(
            100,
            (players[j - 1].points / P) * totalPrizePool
        ); // Calculate prize
        Q += players[j - 1].prize; // Sum up q(j)
    }

    // Step 5: Set q(2) = totalPrizePool - Q
    players[1].prize = totalPrizePool - Q; // Adjust prize for 2nd place

    // Ensure that q(2) is at least $100
    players[1].prize = Math.max(players[1].prize, 100);

    // Calculate any needed adjustments if q(2) was set above $100 and update Q
    Q = players
        .slice(1, topPlayers)
        .reduce((sum, player) => sum + player.prize, 0);

    // Return an array of prizes
    return players.map((player) => Math.round(player.prize));
};
